// extracted by mini-css-extract-plugin
export default {"clear-indicator-base":"ClearIndicatorBase_clear-indicator-base__qawi5"};